<template>
  <AdminShell
    :page-title="pageTitle"
    :page-subtitle="pageSubtitle"
    active-menu="settings"
  >
    <template #actions>
      <el-button icon="el-icon-refresh" @click="refreshAll">刷新全部</el-button>
    </template>

    <div class="settings-page">
      <div class="page-shell">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-card shadow="always" class="settings-card" v-loading="profileLoading">
              <div slot="header" class="card-header">
                <span>商户信息</span>
              </div>

              <el-alert
                v-if="profileError"
                :closable="false"
                type="warning"
                class="card-alert"
                show-icon
              >
                {{ profileError }}
              </el-alert>

              <el-descriptions v-else :column="2" border>
                <el-descriptions-item label="商户 ID">{{ displayValue(merchantProfile.commercialId) }}</el-descriptions-item>
                <el-descriptions-item label="商户名称">{{ displayValue(merchantProfile.merchantName) }}</el-descriptions-item>
                <el-descriptions-item label="登录账号">{{ displayValue(merchantProfile.loginName) }}</el-descriptions-item>
                <el-descriptions-item label="手机号">{{ displayValue(merchantProfile.mobile) }}</el-descriptions-item>
                <el-descriptions-item label="App ID">{{ displayValue(merchantProfile.appid) }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ displayValue(merchantProfile.createdAt) }}</el-descriptions-item>
                <el-descriptions-item label="直播域名">{{ displayValue(merchantProfile.liveDomain) }}</el-descriptions-item>
                <el-descriptions-item label="直播域名状态">{{ displayValue(domainStatusText(merchantProfile.liveStatus, merchantProfile.liveVerified)) }}</el-descriptions-item>
                <el-descriptions-item label="商城域名">{{ displayValue(merchantProfile.shopDomain) }}</el-descriptions-item>
                <el-descriptions-item label="商城域名状态">{{ displayValue(domainStatusText(merchantProfile.shopStatus, merchantProfile.shopVerified)) }}</el-descriptions-item>
              </el-descriptions>
            </el-card>
          </el-col>

          <el-col :span="24">
            <el-card shadow="always" class="settings-card">
              <DomainSettingsPanel
                ref="settingsDomainPanel"
                mode="settings"
                :auto-load="true"
                :show-title="true"
                @loaded="handleDomainState"
                @bound="handleDomainState"
                @verified="handleDomainState"
                @state-change="handleDomainState"
              />
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </AdminShell>
</template>

<script>
import { getUserInfo } from '@/api'
import AdminShell from '@/components/admin/AdminShell.vue'
import DomainSettingsPanel from '@/components/DomainSettingsPanel.vue'
import { domainStatusText } from '@/utils/domain-settings'

const PAGE_TITLE = '\u8bbe\u7f6e\u4e2d\u5fc3'
const PAGE_SUBTITLE = '\u7edf\u4e00\u7ef4\u62a4\u5546\u6237\u4fe1\u606f\u3001\u76f4\u64ad\u57df\u540d\u4e0e\u5546\u57ce\u57df\u540d\u3002'

function buildMerchantProfile(payload = {}) {
  const source = payload?.commercial && typeof payload.commercial === 'object'
    ? { ...payload, ...payload.commercial }
    : payload

  return {
    commercialId: source.commercial_id || source.id || '',
    merchantName:
      source.commercial_name || source.commercialName || source.name || source.shop_name || '',
    loginName: source.username || source.user_name || source.account || '',
    mobile: source.mobile || source.phone || source.tel || '',
    appid: source.appid || source.app_id || '',
    createdAt: source.created_at || source.create_time || source.createdAt || '',
    liveDomain: '',
    liveStatus: '',
    liveVerified: false,
    shopDomain: '',
    shopStatus: '',
    shopVerified: false,
  }
}

export default {
  name: 'SettingsPage',
  components: {
    AdminShell,
    DomainSettingsPanel,
  },
  data() {
    return {
      profileLoading: false,
      profileError: '',
      merchantProfile: buildMerchantProfile(),
      appid: '',
      pageTitle: PAGE_TITLE,
      pageSubtitle: PAGE_SUBTITLE,
    }
  },
  mounted() {
    this.refreshAll()
  },
  methods: {
    domainStatusText,
    displayValue(value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    async loadProfile() {
      this.profileLoading = true
      this.profileError = ''

      try {
        const { data } = await getUserInfo()
        this.merchantProfile = {
          ...this.merchantProfile,
          ...buildMerchantProfile(data),
        }
      } catch (error) {
        this.profileError = error.message || '加载商户信息失败'
      } finally {
        this.profileLoading = false
      }
    },
    async refreshAll() {
      await this.loadProfile()

      if (this.$refs.settingsDomainPanel) {
        this.$refs.settingsDomainPanel.refresh()
      }
    },
    handleDomainState(summary) {
      const live = summary?.recordsMap?.live || {}
      const shop = summary?.recordsMap?.shop || {}

      this.merchantProfile = {
        ...this.merchantProfile,
        liveDomain: live.domain || '',
        liveStatus: live.status || '',
        liveVerified: !!live.verified,
        shopDomain: shop.domain || '',
        shopStatus: shop.status || '',
        shopVerified: !!shop.verified,
      }
    },
  },
}
</script>

<style scoped>
.settings-page {
  min-height: 0;
}

.page-shell {
  max-width: 1280px;
}

.settings-card {
  margin-bottom: 20px;
}

.card-header {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.card-alert {
  margin-bottom: 16px;
}
</style>
